/**
 * @generated SignedSource<<f41c893ddfe3d66df98f50dbc01536a5>>
 * @relayHash ec4bb4fc4b91bdd22636b8cd5a8459f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1b983ca5b9bb7742a71d4d350f250a5524ffb46863ceb1b44624ac1b612ac288

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useFabricEligibilityMigrationQuery$variables = {
  contentId: string;
};
export type useFabricEligibilityMigrationQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly metadata: {
        readonly frontend: {
          readonly contentHash: string | null | undefined;
          readonly fabricEditorEligibility: string | null | undefined;
        } | null | undefined;
      };
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useFabricEligibilityMigrationQuery = {
  response: useFabricEligibilityMigrationQuery$data;
  variables: useFabricEligibilityMigrationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "ContentMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "fabricEditorEligibility"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "contentHash"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useFabricEligibilityMigrationQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useFabricEligibilityMigrationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ec4bb4fc4b91bdd22636b8cd5a8459f5",
    "id": "1b983ca5b9bb7742a71d4d350f250a5524ffb46863ceb1b44624ac1b612ac288",
    "metadata": {},
    "name": "useFabricEligibilityMigrationQuery",
    "operationKind": "query",
    "text": "query useFabricEligibilityMigrationQuery($contentId:ID!){content(id:$contentId){nodes{id,metadata{frontend{fabricEditorEligibility,contentHash}}}}}"
  }
};
})();

(node as any).hash = "204d8fbd9ab341cec958fee25e721167";

export default node;
